import React, { useEffect, useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Context as RestaurantContext } from '../context/restaurant';
import { Context as CartContext } from '../context/cart';
import { Context as AlertContext } from '../context/alert';
import MainLayout from '../layouts/mainLayout';
import Menu from '../features/menu/components/menu';
import OrderMenu from '../features/menu/components/order/orderMenu';
import Loader from '../components/misc/loader';
import { restaurantTypes } from '../enums/restaurantTypes';
import { useTableSseConnection } from '../hooks/useTableSseConnection';

const MenuPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useTableSseConnection();

  const { state: restaurantState, getMenu } = useContext(RestaurantContext);
  const { applyDiscounts } = useContext(CartContext);
  const { alertController } = useContext(AlertContext);

  const getMenuAsync = async () => {
    const { locked, menu, discountCartService } = await getMenu();

    if (restaurantState.restaurant.type === restaurantTypes.OrderAndPay) {
      applyDiscounts(discountCartService);
    } else if (!locked && !menu) {
      alertController.warning({ text: t('errors.noMenu') });
      navigate('/', { replace: true });
    }
  };

  useEffect(() => {
    if (restaurantState.menuGot) {
      return;
    }

    getMenuAsync();
  }, []);

  const { displayProductsMenu, productsOnlyForDisplay } = useMemo(() => {
    if (restaurantState.restaurant.type === restaurantTypes.OrderAndPay) {
      return { displayProductsMenu: true, productsOnlyForDisplay: false };
    }

    if (restaurantState.menu) {
      if (restaurantState.menu.type === 'Products') {
        return { displayProductsMenu: true, productsOnlyForDisplay: true };
      }
    }

    return { displayProductsMenu: false };
  }, [restaurantState.menu, restaurantState.productCategories]);

  // Loading table
  if (restaurantState.loadingMenu || !restaurantState.menuGot) {
    return <Loader />;
  }

  return (
    <MainLayout noFooter={displayProductsMenu && !productsOnlyForDisplay}>
      {displayProductsMenu && (
        <OrderMenu
          productCategories={restaurantState.productCategories}
          onlyDisplay={productsOnlyForDisplay}
        />
      )}
      {!displayProductsMenu && <Menu menu={restaurantState.menu} />}
    </MainLayout>
  );
};

export default MenuPage;
